// extracted by mini-css-extract-plugin
export default {"info-modal":"components-settings-currency-conversion-modals-not-found-profile-module__info-modal"};